module.exports = __webpack_public_path__ + "static/img/Hamiso-Tabuai-Fidow.e466962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamiso-Tabuai-Fidow.jpg
// module id = Yu1P
// module chunks = 0